{
  "Sidebar": {
    "badges": {
      "beta": "Beta"
    },
    "guest": {
      "title": "Speichere deine Arbeit",
      "description": "Melde dich kostenlos an, um deine Klausuren, Chats und Einstellungen dauerhaft zu speichern.",
      "loginButton": "Jetzt Anmelden"
    },
    "actions": {
      "newExamTitle": "Neue Klausur erstellen",
      "creating": "Erstelle...",
      "newExam": "Neue Klausur"
    },
    "examList": {
      "title": "Meine Klausuren",
      "noExams": "Keine Klausuren gefunden.",
      "unnamed": "Unbenannt",
      "unnamedExam": "Unbenannte Klausur",
      "loadOlder": "Ältere Klausuren laden"
    },
    "examMenu": {
      "edit": "Bearbeiten",
      "addToClass": "Zu Klasse hinzufügen",
      "delete": "Löschen"
    },
    "bottomNav": {
      "profile": "Profil",
      "settings": "Einstellungen",
      "feedback": "Feedback geben",
      "classroom": "Klassen",
      "joinClass": "Klasse beitreten"
    },
    "dialogs": {
      "renameTitle": "Klausur bearbeiten",
      "groupTitle": "Klausur gruppieren",
      "renameDesc": "Bearbeite die Informationen der Klausur.",
      "groupDesc": "Wähle eine Klasse oder Gruppe für diese Klausur aus.",
      "fields": {
        "name": "Name",
        "subject": "Fach",
        "topic": "Thema",
        "class": "Klasse",
        "placeholderSelect": "Bitte wählen..."
      },
      "save": "Speichern"
    },
    "alerts": {
      "deleteConfirm": "Möchtest du diese Klausur wirklich löschen?",
      "saveFailed": "Speichern fehlgeschlagen"
    }
  },
  "Settings": {
    "title": "Einstellungen",
    "soon": "Demnächst",
    "DisplayAndLanguage": {
      "title": "Darstellung & Sprache",
      "languageLabel": "Sprache",
      "languageDesc": "Wähle die Sprache der Benutzeroberfläche.",
      "themeLabel": "Erscheinungsbild",
      "themeDesc": "Wechsle zwischen hellem und dunklem Modus."
    },
    "AI": {
      "title": "KI & Korrektur",
      "strictnessLabel": "KI-Unsicherheit",
      "strictnessDesc": "Bestimmt, bei welcher KI-Sicherheit du Aufgaben zwingend manuell überprüfen musst.",
      "strictnessWarning": "Achtung: Bei „Hoher Autonomie“ greifst du nur noch bei starker Unsicherheit der KI manuell ein...",
      "gradingKindnessLabel": "Bewertungsstrenge",
      "gradingKindnessDesc": "Legt fest, wie streng die KI das Bewertungsschema auslegt. Freundlich bevorzugt den Schüler im Zweifel, Streng bewertet exakt nach Schema.",
      "gradingKindnessOptions": {
        "lenient": "Freundlich",
        "balanced": "Ausgewogen",
        "strict": "Streng"
      }
    },
    "Notifications": {
      "title": "Benachrichtigungen",
      "soon": "Demnächst",
      "emailLabel": "E-Mail Benachrichtigungen",
      "emailDesc": "Erhalte E-Mail Benachrichtigungen über wichtige Ereignisse",
      "browserLabel": "Browser Benachrichtigungen",
      "browserDesc": "Push-Benachrichtigungen direkt in deinem Browser erhalten"
    },
    "About": {
      "title": "Über Gradias",
      "landingPage": "gradias.ai besuchen",
      "support": "Hilfe & Support",
      "imprint": "Impressum",
      "privacy": "Datenschutzerklärung"
    },
    "Account": {
      "title": "Daten & Konto",
      "exportLabel": "Meine Daten exportieren",
      "exportDesc": "Lade alle hochgeladenen Klausuren und Ergebnisse als ZIP herunter",
      "deleteLabel": "Mein Konto löschen",
      "deleteDesc": "Deine Daten und alle zugehörigen Daten unwiderruflich löschen"
    }
  },
  "Profile": {
    "title": "Profil",
    "actions": {
      "cancel": "Abbrechen",
      "save": "Speichern",
      "edit": "Bearbeiten",
      "remove": "Entfernen"
    },
    "alerts": {
      "saveError": "Profil konnte nicht gespeichert werden.",
      "generalError": "Es ist ein Fehler aufgetreten."
    },
    "personal": {
      "firstName": "Vorname",
      "lastName": "Nachname",
      "name": "Name",
      "school": "Schule",
      "noSchool": "Keine Schule angegeben",
      "email": "Email",
      "emailHint": "Email kann hier nicht geändert werden.",
      "defaultUser": "User",
      "role": {
        "teacher": "Lehrkraft",
        "student": "Schüler:in"
      }
    },
    "teaching": {
      "subjects": "Meine Fächer",
      "addSubjectPlaceholder": "Fächer suchen oder eingeben…",
      "addCustomSubject": "„{{value}}“ hinzufügen"
    },
    "rules": {
      "title": "Regeln & Präferenzen",
      "description": "Gespeicherte Präferenzen, an die sich der Assistent hält – beim Chatten, Bewerten und beim Erstellen von Musterlösungen und Bewertungsschemata. Du kannst sie hier selbst bearbeiten, aber der Assistent passt sie auf Wunsch auch direkt im Chat für dich an.",
      "general": "Allgemein",
      "empty": "Noch keine Regeln gespeichert.",
      "addRule": "Regel hinzufügen",
      "removeRule": "Regel entfernen",
      "limitReached": "Maximum erreicht",
      "limitHint": "Maximal {{max}} Regeln pro Kategorie",
      "placeholder": "Regel beschreiben …",
      "categories": {
        "chat_and_workflow": "Chat & Arbeitsablauf",
        "grading_and_feedback": "Bewertung & Feedback",
        "master_solution_design": "Musterlösungen",
        "grading_scheme_creation": "Bewertungsschemata"
      },
      "categoryDescs": {
        "chat_and_workflow": "Wie der Assistent im Chat antwortet und den Arbeitsablauf steuert",
        "grading_and_feedback": "Wie Antworten bewertet und Feedback formuliert wird",
        "master_solution_design": "Wie Musterlösungen erstellt werden",
        "grading_scheme_creation": "Wie Bewertungsschemata aufgebaut werden"
      },
      "grammar": {
        "alwaysUseFi": "Immer Fehlerindex (FI) verwenden",
        "alwaysUseFiDesc": "Nutzt standardmäßig den Fehlerindex statt erkannter Grammatik-Regeln aus einem hochgeladenen Bewertungsschema. Kann pro Klausur überschrieben werden.",
        "languageUseRegradeWordCutoff": "Automatische Neubewertung der sprachlichen Leistung ab (Wörter)",
        "languageUseRegradeWordCutoffDesc": "Bei einer Bearbeitung der Schülerantwort wird die sprachliche Leistung der betroffenen Gruppe automatisch neu bewertet, sobald mindestens so viele Wörter geändert wurden (mehrere kleine Änderungen zählen zusammen).",
        "contentRegradeWordCutoff": "Automatische Neubewertung des Inhalts ab (Wörter)",
        "contentRegradeWordCutoffDesc": "0 = immer (Standard) – der Inhalt wird bei jeder Textänderung sofort neu bewertet. Ein höherer Wert überspringt die automatische Neubewertung bei sehr kleinen Änderungen."
      }
    },
    "security": {
      "title": "Account & Sicherheit",
      "changePassword": "Passwort ändern",
      "changePasswordDesc": "Sicherheit deines Kontos verwalten",
      "logout": "Abmelden",
      "logoutDesc": "Sicher von diesem Gerät ausloggen"
    },
    "badges": {
      "soon": "Demnächst"
    }
  },
  "ClassInsights": {
    "overview": "Übersicht",
    "examCount": "Klausuren",
    "subjectCount": "Fächer",
    "gradedCount": "Bewertet",
    "averageGrade": "Ø Note",
    "averageGradeShort": "Ø {{grade}}",
    "examListTitle": "Klausuren in dieser Klasse",
    "noExams": "Noch keine Klausuren in dieser Klasse.",
    "loading": "Lade Einblicke …",
    "statusGraded": "Bewertet",
    "statusInProgress": "In Bearbeitung",
    "unnamedExam": "Unbenannte Klausur",
    "unknownSubject": "Unbekanntes Fach"
  },
  "Classroom": {
    "title": "Klassen",
    "createButton": "Klasse erstellen",
    "loading": "Lädt …",
    "noClasses": "Du hast noch keine Klasse erstellt.",
    "pendingCount": "{{count}} ausstehend",
    "copyCode": "Code kopieren",
    "copyLink": "Link kopieren",
    "joinCodeLabel": "Beitrittscode",
    "regenerateCode": "Code neu generieren",
    "pendingRequestsTitle": "Ausstehende Anfragen",
    "noPendingRequests": "Keine ausstehenden Anfragen.",
    "noPendingRequestsHint": "Neue Beitrittsanfragen erscheinen hier.",
    "rosterTitle": "Schüler:innen",
    "noStudents": "Noch keine Schüler:innen.",
    "noStudentsHint": "Teile den Beitrittscode, damit deine Klasse hier auftaucht.",
    "noClassesHint": "Erstelle deine erste Klasse, um loszulegen.",
    "studentCount_one": "{{count}} Schüler:in",
    "studentCount_other": "{{count}} Schüler:innen",
    "approve": "Annehmen",
    "reject": "Ablehnen",
    "studentOptions": "Optionen",
    "editStudent": "Bearbeiten",
    "removeStudent": "Entfernen",
    "showQrCode": "QR-Code anzeigen",
    "qrCodeDialogTitle": "Beitrittscode",
    "qrCodeDialogHint": "Klasse scannen und beitreten",
    "createDialog": {
      "title": "Neue Klasse erstellen",
      "namePlaceholder": "Klassenname, z. B. 10b Mathe",
      "cancel": "Abbrechen",
      "confirm": "Erstellen"
    },
    "alerts": {
      "createError": "Klasse konnte nicht erstellt werden. Bitte versuche es erneut.",
      "decideError": "Anfrage konnte nicht bearbeitet werden. Bitte versuche es erneut.",
      "regenerateError": "Code konnte nicht neu generiert werden. Bitte versuche es erneut."
    }
  },
  "JoinClass": {
    "title": "Klasse beitreten",
    "enterCodeTitle": "Klassencode eingeben",
    "codePlaceholder": "ABC123",
    "findButton": "Suchen",
    "codeNotFound": "Für diesen Code wurde keine Klasse gefunden.",
    "confirmJoin": "Beitrittsanfrage für „{{className}}“ senden?",
    "requestButton": "Beitreten anfragen",
    "alreadyRequested": "Du hast bereits eine Anfrage für „{{className}}“ gestellt.",
    "myClassesTitle": "Meine Klassen",
    "loading": "Lädt …",
    "noClasses": "Du bist noch keiner Klasse beigetreten.",
    "status": {
      "pending": "Ausstehend",
      "approved": "Angenommen",
      "rejected": "Abgelehnt"
    },
    "alerts": {
      "joinError": "Beitrittsanfrage konnte nicht gesendet werden. Bitte versuche es erneut."
    }
  },
  "JoinLanding": {
    "loading": "Lädt …",
    "noCode": "Dieser Link enthält keinen Klassencode.",
    "teacherAccountNotice": "Dieser Link dient dazu, als Schüler:in einer Klasse beizutreten. Du bist aktuell als Lehrkraft angemeldet.",
    "joinTitle": "Tritt „{{className}}“ bei",
    "joinSubtitle": "Melde dich an oder registriere dich, um deiner Lehrkraft eine Beitrittsanfrage zu schicken.",
    "codeNotFound": "Dieser Code wurde nicht gefunden. Bitte prüfe den Link.",
    "signUpButton": "Registrieren",
    "logInButton": "Anmelden"
  },
  "Dashboard": {
    "guestMessage": "Ich bin gradi, dein KI-Klausurkorrekturassistent.",
    "greetings": {
      "opt1": "Welche Klausuren korrigieren wir heute?",
      "opt2": "Lass uns deinen Klausurenstapel abarbeiten.",
      "opt3": "Was steht heute an?",
      "opt4": "Wie kann ich dir heute helfen?",
      "opt5": "Schön, dass du da bist. Womit fangen wir an?",
      "opt6": "Lass uns loskorrigieren!"
    },
    "studentGreetings": {
      "opt1": "Was lernen wir heute?",
      "opt2": "Lass uns ein paar Klausurfragen angehen.",
      "opt3": "Was steht heute an?",
      "opt4": "Wie kann ich dir heute helfen?",
      "opt5": "Schön, dass du da bist. Womit fangen wir an?",
      "opt6": "Los geht's!"
    },
    "fallbackGreeting": "Was steht heute an?",
    "greetingPrefix": "Hi",
    "inputPlaceholder": "Stelle eine Frage...",
    "dropzoneText": "Dateien hier ablegen",
    "actions": {
      "startGrading": {
        "label": "Klausurkorrektur starten",
        "prompt": "Ich möchte eine neue Klausurkorrektur starten. Bitte führe mich Schritt für Schritt durch den Prozess vom Upload bis zum Bewertungsschema."
      },
      "uploadExam": {
        "label": "Klausur hochladen",
        "prompt": "Ich möchte eine Klausur, die ich bereits bearbeitet habe, hochladen, damit du sie für mich korrigierst. Wie fangen wir an?"
      },
      "createExam": {
        "label": "Klausur erstellen",
        "prompt": "Ich möchte eine neue Übungsklausur erstellen. Kannst du mir dabei helfen, eine zusammenzustellen?"
      },
      "howItWorks": {
        "label": "Wie funktioniert gradias?",
        "prompt": "Erkläre mir bitte kurz und knapp, wie gradias funktioniert und welche Schritte ich für eine erfolgreiche Korrektur durchlaufen muss."
      },
      "sampleData": {
        "label": "Mit Beispieldaten testen",
        "prompt": "Ich möchte das System testen, habe aber keine eigenen Klausuren zur Hand. Wie kann ich mit einer Beispielklausur testen?"
      },
      "taskTypes": {
        "label": "Welche Aufgabentypen gibt es?",
        "prompt": "Welche Arten von Aufgaben (z.B. Freitext, Multiple-Choice, Mathe-Gleichungen) kannst du aktuell korrigieren?"
      },
      "privacy": {
        "label": "Datenschutz und Sicherheit",
        "prompt": "Wie geht gradias mit dem Thema Datenschutz um? Was passiert mit den hochgeladenen Klausuren meiner Schüler?"
      }
    },
    "alerts": {
      "uploadError": "Fehler beim Hochladen der Datei",
      "noExamId": "Keine examId vorhanden"
    },
    "aria": {
      "uploadFiles": "Dateien hochladen",
      "submit": "Abschicken",
      "removeFile": "Datei entfernen"
    }
  },
  "ChatInput": {
    "statusLabels": {
      "allComplete": "Alle Schritte abgeschlossen",
      "configRunning": "Fertig - Bereit zum Fortfahren",
      "readyForConfig": "Bereit für Konfiguration",
      "status": "Status",
      "progress": "Fortschritt",
      "inProgress": "laufend"
    },
    "steps": {
      "examCreator": {
        "label": "Klausur erstellen",
        "phasePlan": "Klausur wird geplant",
        "phaseMaterial": "Material wird erstellt",
        "phaseSource": "Aufgaben werden geschrieben",
        "phaseRepair": "Dokument wird fertiggestellt"
      },
      "upload": {
        "label": "Dateiupload"
      },
      "studentAssignment": {
        "label": "Schülerzuordnung",
        "activeWait": "Warte auf Bestätigung",
        "activeAssign": "Schülerabgaben zuweisen"
      },
      "structure": {
        "label": "Klausurstruktur",
        "active": "Aufgaben werden erkannt"
      },
      "answers": {
        "label": "Schülerantworten",
        "active": "Antworten werden verarbeitet"
      },
      "masterSolution": {
        "label": "Musterlösung",
        "activeDetect": "Musterlösung wird erkannt",
        "activeCreate": "Musterlösung wird erstellt",
        "activeComplete": "Musterlösung wird ergänzt"
      },
      "gradingScheme": {
        "label": "Bewertungskriterien",
        "activeDetect": "Bewertungskriterien werden erkannt",
        "activeCreate": "Bewertungskriterien werden erstellt",
        "activeComplete": "Bewertungskriterien werden ergänzt"
      },
      "grading": {
        "label": "Korrektur",
        "active": "Korrektur läuft"
      },
      "summary": {
        "label": "Ergebnisübersicht"
      }
    },
    "badges": {
      "uncertainties": "Unsicherheiten",
      "errorRegions": "Fehlerhafte Regionen",
      "errorSubmissions": "Fehlerhafte Abgaben",
      "documentEncrypted": "Dokument verschlüsselt"
    },
    "ui": {
      "showProgress": "Korrekturfortschritt anzeigen",
      "dropFilesHere": "Dateien hier ablegen",
      "uploadFiles": "Dateien hochladen",
      "waitUpload": "Upload abwarten",
      "sendMessage": "Nachricht senden",
      "privacyNotice": "100% DSGVO-konform. Deine Daten und Schülerdokumente werden nicht für KI-Training verwendet.",
      "learnMore": "Mehr erfahren."
    },
    "alerts": {
      "uploadError": "Fehler beim Hochladen der Datei",
      "noExamId": "Keine examId vorhanden"
    }
  },
  "TokenInput": {
    "placeholder": "Stelle eine Frage..."
  },
  "Chat": {
    "auth": {
      "login": "Anmelden",
      "register": "Registrieren"
    },
    "loading": {
      "masterSolutions": "Lade Musterlösungen...",
      "examData": "Lade Klausurdaten & Bilder...",
      "extractingTasks": "Aufgaben werden extrahiert... {{finished}}/{{total}}",
      "splitThinkingMessage": "Ich ordne die Schülerabgaben zu",
      "structureThinkingMessage": "Ich erkenne die Klausurstruktur",
      "examStructure": "Lade Klausurstruktur...",
      "pages": "Lade Seiten...",
      "summary": "Lade Zusammenfassung..."
    },
    "alerts": {
      "errorOccurred": "Sorry, ein Fehler ist aufgetreten. Bitte versuche es später noch einmal.",
      "reportsBlocked": "PDF-Reports sind erst verfügbar, wenn alle Hauptaufgaben freigegeben sind oder eine KI-Sicherheit über {{threshold}}% besteht.",
      "noSubmissionsForReports": "Keine Submissionen mit Berichtsdaten gefunden.",
      "reportsFailed": "PDF-Berichte konnten nicht erstellt werden. Bitte erneut versuchen."
    },
    "sampleExamIntro": "Ich möchte diese Klausur mit folgenden Dokumenten korrigieren:\n{{lines}}",
    "canvasTitles": {
      "boundingbox": "Aufgabenbereiche anpassen",
      "msedit": "Musterlösung/ Bewertungsschema bearbeiten",
      "correction": "Korrektur",
      "summary": "Korrektur-Zusammenfassung",
      "structureeditor": "Klausurstruktur bearbeiten",
      "submissioncheck": "Seitenzuordnung überprüfen",
      "demoselector": "Demo auswählen",
      "examcreator": "Klausur erstellen",
      "default": "Detailansicht"
    }
  },
  "Canvas": {
    "common": {
      "resize": "Größe anpassen",
      "toSummaryTitle": "Zur Übersicht",
      "backToSummary1": "Zurück zur",
      "backToSummary2": "Übersicht",
      "restore": "Wiederherstellen",
      "fullscreen": "Vollbild",
      "close": "Schließen",
      "emptyTitle": "Noch nichts zu sehen",
      "emptyDescription": "Hier erscheinen Inhalte, sobald es etwas zu zeigen gibt."
    },
    "grading": {
      "prevTask": "Vorherige Aufgabe",
      "nextTask": "Nächste Aufgabe",
      "taskXofY": "Aufgabe {{current}} von {{total}}",
      "taskName": "Aufgabe {{number}}",
      "nextUncertainty": "Nächste Unsicherheit ({{count}})",
      "uncertaintiesLeft": "{{count}} Unsicherheiten übrig",
      "backToSummary1": "Zurück zur",
      "backToSummary2": "Übersicht",
      "submissionX": "Abgabe {{id}}",
      "pages": "Seiten:",
      "pageX": "Seite {{page}}",
      "addBoundingBox": "Neue Bounding Box hinzufügen",
      "extractedText": "Extrahierter Text",
      "verified": "Geprüft",
      "consistencyAdjusted": "Zur Konsistenz mit anderen Abgaben automatisch angepasst",
      "bboxConfidence": "BBox-Sicherheit: {{conf}}%",
      "review": "Prüfen",
      "noTextExtracted": "Kein Text extrahiert.",
      "imageContent": "Bild (keine Texterkennung) - der erkannte Bildausschnitt wird direkt zur weiteren Verarbeitung verwendet",
      "aiGrading": "KI-Bewertung",
      "pts": "Pkt.",
      "points": "Punkte:",
      "noGradingYet": "Noch keine Bewertung vorhanden.",
      "gradingScheme": "Bewertungsschema",
      "expand": "Aufklappen",
      "collapse": "Einklappen",
      "maxPoints": "Max Punkte: {{points}}",
      "noGradingSchemeYet": "Noch kein Bewertungsschema vorhanden.",
      "boxModeContent": "Inhalt",
      "boxModeLanguageUse": "Sprachliche Leistung",
      "groupLanguageUseRule": "Gruppe: Aufgabe {{tasks}}",
      "groupLanguageUseRuleNumbered": "Gruppe {{number}}: Aufgabe {{tasks}}",
      "editLanguageUseGroupTasks": "Aufgaben dieser Gruppe bearbeiten",
      "deleteLanguageUseGroup": "Diese Regel für die sprachliche Leistung löschen",
      "deleteLanguageUseGroupConfirm": "Möchtest du diese Regel für die sprachliche Leistung wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "deleteLanguageUseGroupBlocked": "Löschen ist während der Benotung nicht möglich.",
      "languageUseGroupPickerInfo": "Aufgabe anhaken, um sie dieser Gruppe hinzuzufügen. Abhaken entfernt sie – falls sie weiterhin eine eigene Regel für die sprachliche Leistung benötigt, wird sie mit dem Text dieser Gruppe und 0 Punkten vorausgefüllt, damit du sie wiederfindest.",
      "languageUseGroupPickerSaveFailed": "Speichern fehlgeschlagen. Bitte erneut versuchen.",
      "languageUseGroupPickerEmptyDraft": "Eine Regel benötigt mindestens eine Aufgabe.",
      "deleteBox": "Bounding Box löschen",
      "retryOcr": "Texterkennung wiederholen",
      "unlockBox": "Bounding Box entsperren",
      "lockBox": "Bounding Box sperren",
      "noSubmissionsFound": "Keine Abgaben gefunden.",
      "examPageX": "Klausurseite {{page}}",
      "modeCorrection": "Korrektur",
      "modeGrammar": "Grammatik",
      "grammarTitle": "Rechtschreibung & Grammatik",
      "grammarErrors": "Fehler",
      "fehlerindex": "Fehlerindex",
      "words": "Wörter",
      "noGrammarErrors": "Keine Fehler gefunden.",
      "noGrammarEvaluationForTask": "Keine Grammatikauswertung für diese Aufgabe.",
      "notLocated": "Nicht auf dem Bild lokalisiert",
      "notLocatedShort": "ohne Markierung",
      "deleteGrammarError": "Fehler entfernen",
      "editGrammarError": "Fehler bearbeiten",
      "saveGrammarError": "Speichern",
      "addMistake": "Fehler hinzufügen",
      "mistakePlaceholder": "Fehlerbeschreibung…",
      "errorCategories": {
        "TYPOS": "Tippfehler",
        "GRAMMAR": "Grammatik",
        "SEMANTICS": "Semantik",
        "STYLE": "Stil",
        "PUNCTUATION": "Interpunktion",
        "TYPOGRAPHY": "Typografie",
        "REDUNDANCY": "Redundanz",
        "CASING": "Groß-/Kleinschreibung",
        "COLLOCATIONS": "Kollokationen",
        "CONFUSED_WORDS": "Verwechslungen",
        "FALSE_FRIENDS": "Falsche Freunde",
        "GENDER_NEUTRALITY": "Geschlechterneutralität",
        "IDIOMS": "Idiome",
        "MISC": "Sonstiges",
        "NONSTANDARD_PHRASES": "Nicht-standardisierte Ausdrücke",
        "PLAIN_ENGLISH": "Einfache Sprache",
        "PROPER_NOUNS": "Eigennamen",
        "REGIONALISMS": "Regionalismen"
      },
      "rerunningOcr": "Texterkennung wird wiederholt...",
      "regrading": "Wird neu bewertet...",
      "regradingQueued": "In der Warteschlange..."
    },
    "msgs": {
      "noTasksFound": "Keine Aufgaben gefunden.",
      "prevTask": "Vorherige Aufgabe",
      "nextTask": "Nächste Aufgabe",
      "task": "Aufgabe",
      "taskMain": "Aufgabe {{main}}",
      "taskSub": "Aufgabe {{main}}.{{sub}}",
      "uncertaintiesLeft": "{{count}} Unsicherheiten übrig",
      "nextUncertainty": "Nächste Unsicherheit ({{count}})",
      "taskExcerpt": "Aufgabenausschnitt",
      "noImageAvailable": "Kein Bild verfügbar...",
      "masterSolution": "Muster​lösung",
      "aiGeneratedProposalTooltip": "Von der KI generierter Vorschlag",
      "aiGeneratedProposal": "KI-generierter Vorschlag",
      "review": "Prüfen",
      "approvalRequiresPoints": "Bestätigen ist erst möglich, wenn die Punktzahl größer als 0 ist.",
      "saveRequiresPoints": "Speichern ist erst möglich, wenn die Punktzahl größer als 0 ist.",
      "enterMasterSolution": "Musterlösung hier eingeben...",
      "noMasterSolutionYet": "Noch keine Musterlösung vorhanden...",
      "gradingScheme": "Bewertungsschema",
      "maxPoints": "Max Punkte",
      "maxPointsValue": "Max Punkte: {{points}}",
      "enterGradingScheme": "Bewertungsschema hier eingeben...",
      "noGradingSchemeYet": "Noch kein Bewertungsschema vorhanden...",
      "gradingSchemeRefining": "Bewertungsschema wird aktualisiert...",
      "masterSolutionRefining": "Musterlösung wird aktualisiert..."
    },
    "submissionCheck": {
      "pageShort": "S. {{page}}",
      "zoomPage": "Seite {{page}} vergrößern",
      "pageAlt": "Seite",
      "loading": "Lädt...",
      "newStudent": "Neuer Schüler",
      "readOnly": "Read-only",
      "saveAssignment": "Zuordnung speichern",
      "unassignedPagesTitle": "Klärungsbedarf: Unzugewiesene Seiten ({{count}})",
      "unassignedPagesHint": "Bitte ziehe diese Seiten in die Ordner der Schüler.",
      "newStudentIndexed": "Neuer Schüler {{index}}",
      "studentIndexed": "Schüler {{index}}",
      "enterName": "Name eingeben...",
      "pageX_one": "{{count}} Seite",
      "pageX_other": "{{count}} Seiten",
      "splitConfidenceHover": "Split confidence: {{percent}}%",
      "splitPercent": "Split {{percent}}%",
      "deleteStudent": "Schüler löschen",
      "dragHint": "Zieh Dokumente hierher, um sie {{name}} zuzuordnen",
      "assignmentNotes": "Hinweise zur Zuordnung",
      "previewPageAlt": "Vorschau Seite {{page}}",
      "pageCurrentOfTotal": "Seite {{current}} von {{total}}",
      "locked": "Bestätigt",
      "lockedHint": "Bereits bestätigt – kann nicht mehr bearbeitet werden."
    },
    "summary": {
      "studentsOverview": "Zusammenfassung pro Schüler",
      "studentsOverviewDesc": "Detaillierte Punkte und KI-Bewertung pro Aufgabe",
      "searchStudent": "Schülername suchen...",
      "student": "Schüler",
      "pointsAbbr": "P.",
      "total": "Gesamt",
      "percentage": "Prozent",
      "grade": "Note",
      "noHits": "Keine Treffer.",
      "aiConfidenceHover": "KI-Sicherheit: {{percent}}% - Bitte manuell überprüfen",
      "aiUncertainties": "KI-Unsicherheiten",
      "aiUncertaintiesDesc": "Überprüfe Fälle, bei denen die KI unsicher ist, um faire Bewertungen sicherzustellen.",
      "openDecisions": "{{count}} offene Entscheidungen",
      "sortBy": "Sortieren nach",
      "task": "Aufgabe",
      "aiUncertainty": "KI-Unsicherheit",
      "confidence": "KI-Sicherheit:",
      "points": "Punkte:",
      "toGrading": "Zum Grading",
      "confirmed": "Bestätigt",
      "confirm": "Bestätigen",
      "noClarificationNeeded": "Kein Klärungsbedarf.",
      "worstAvg": "Schlechtester Schnitt",
      "noDataYet": "Noch keine Daten",
      "avgSuffix": "im Mittel",
      "frequentErrors": "Häufigste Fehlerquellen",
      "metricsPerTask": "Metriken je Aufgabe",
      "gradeDistribution": "Notenspiegel",
      "count": "Anzahl",
      "pdfReports": "PDF Reports",
      "downloadingPdf": "PDF Reports werden erstellt...",
      "downloadPdf": "PDF Reports herunterladen",
      "csvExport": "CSV Notenexport",
      "notConnected": "Noch nicht verbunden",
      "notMet": "Nicht erfüllt",
      "downloadingCsv": "CSV wird erstellt...",
      "downloadCsv": "CSV herunterladen",
      "gradeScale": "Notenschlüssel",
      "gradeFrom": "Note {{grade}} ab",
      "normalDistribution": "Normalverteilung (Gauß-Kurve)",
      "activated": "Aktiviert",
      "deactivated": "Deaktiviert",
      "curveStrength": "Curving-Stärke",
      "curvingComingSoon": "Curving ist noch nicht verfügbar. Diese Funktion folgt in Kürze.",
      "noSubmissionsFound": "Keine korrigierten Abgaben gefunden.",
      "avgPointsReached": "Ø Erreichte Punkte",
      "pointsReached": "Erreichte Punkte",
      "gradeSystem": "Notensystem",
      "gradeBorders": "Notengrenzen",
      "lowestGradeLabel": "unterste Note (ab 0%)",
      "tabs": {
        "students": "Schülerübersicht",
        "clarification": "Klärungsbedarf",
        "insights": "Aufgaben-Insights",
        "grades": "Notenspiegel",
        "curving": "Notenschlüssel & Curving",
        "export": "Export",
        "languageUse": "Sprachliche Leistung & Grammatik"
      },
      "gradingScales": {
        "german16": "Deutsch (1–6)",
        "drittel": "Drittel (1.0–5.0)",
        "af": "A–F",
        "gpa4": "4.0 GPA",
        "notenpunkte": "Notenpunkte (0–15)",
        "numeric10": "10-Punkte",
        "percentage": "Prozent",
        "custom": "Benutzerdefiniert"
      },
      "grammar": "Grammatik",
      "fehlerindex": "Fehlerindex",
      "grammarFiColumnHint": "Enthält nur Aufgaben, die noch über den Fehlerindex bewertet werden; regelbasierte Aufgaben haben eigene Spalten.",
      "taskLanguageUseColumn": "{{label}} · Sprachliche Leistung",
      "grammarTab": {
        "noGrammarTasks": "Diese Klausur enthält keine Aufgaben mit Grammatik-Bewertung.",
        "fiTitle": "Fehlerindex-Abzug",
        "fiDesc": "Fehlerindex = Fehler pro 100 Wörter. Bei Überschreiten der Grenzen wird die Gesamtnote um Notenschritte abgesenkt.",
        "fiUnsupportedScale": "Für Prozent-Notenschlüssel ist kein Notenschritt-Abzug möglich.",
        "fiAbove": "Bei Fehlerindex über",
        "deductSteps": "Abzug (Notenschritte)",
        "matrixTitle": "Grammatikfehler pro Schüler und Aufgabe",
        "matrixDesc": "Anzahl der Fehler (Fehlerindex in Klammern). Klick auf eine Zelle öffnet die Korrektur im Grammatik-Modus.",
        "fiSwitchTitle": "Fehlerindex für diese Klausur anwenden",
        "fiSwitchDesc": "Übernimmt standardmäßig deine Profileinstellung; zum Überschreiben nur für diese Klausur umschalten.",
        "gradeWithFi": "Note (mit FI)"
      },
      "languageUseTab": {
        "rulesOverviewTitle": "Für die Bewertung verwendete Regeln zur sprachlichen Leistung",
        "ownRuleEntry": "{{label}}: eigene Regel ({{points}} Pkt.)",
        "groupRuleEntry": "{{label}} ({{points}} Pkt.)",
        "teacherRulesActive": "Die sprachliche Leistung wird über deine persönlichen Regeln direkt in der Bewertung berücksichtigt. Der Fehlerindex-Abzug ist deaktiviert."
      }
    },
    "structureEditor": {
      "noPages": "Keine Seiten vorhanden.",
      "taskAreasDetected_one": "{{count}} Aufgabenbereich erkannt",
      "taskAreasDetected_other": "{{count}} Aufgabenbereiche erkannt",
      "addArea": "Bereich hinzufügen",
      "remove": "Entfernen",
      "resetZoom": "Zoom zurücksetzen",
      "readOnly": "Read-only",
      "saving": "Speichere...",
      "saved": "Gespeichert",
      "blankExamPage": "Blanke Klausurseite {{page}}",
      "deleteBbx": "BBX löschen",
      "retryOcr": "Texterkennung wiederholen",
      "noTasksOnPage": "Keine Aufgaben auf dieser Seite",
      "task": "Aufgabe",
      "noText": "Kein Text",
      "imageContent": "Bild (keine Texterkennung) - der erkannte Bildausschnitt wird direkt zur weiteren Verarbeitung verwendet",
      "additionalInfo": "Zusatzinfo",
      "noContent": "Kein Inhalt",
      "linkedTasks": "Verknüpfte Aufgaben",
      "noTasks": "Keine Aufgaben",
      "pointsInconsistent": "Die Punkte passen nicht zusammen. Vergib pro Ebene entweder allen Aufgaben Punkte (Summe = Gesamtpunkte der übergeordneten Aufgabe) oder keiner. Bitte die markierten Aufgaben korrigieren:",
      "pointsInconsistentTask": "Aufgabe {{path}} fehlen Punkte",
      "totalPoints": "Gesamtpunkte (inkl. Teilaufgaben)",
      "ownPoints": "Eigene Punkte (eigene Antwort dieser Aufgabe)",
      "tasksWithoutRegion": "Aufgaben ohne markierten Bereich",
      "taskType": "Aufgabentyp"
    },
    "demoSelector": {
      "title": "Demo auswählen",
      "description": "Wähle eine Beispielklausur. gradias simuliert den Upload und startet die Extraktion automatisch.",
      "examCount_one": "{{count}} Klausur",
      "examCount_other": "{{count}} Klausuren",
      "studentCount_one": "{{count}} Schüler",
      "studentCount_other": "{{count}} Schüler",
      "examLanguage": "Klausursprache",
      "subjects": {
        "math": "Mathematik",
        "english": "Englisch",
        "technical": "Berufsschule",
        "biology": "Biologie",
        "spanish": "Spanisch",
        "french": "Französisch",
        "physics": "Physik",
        "political_education": "Politik",
        "german": "Deutsch"
      },
      "grades": {
        "gesamtschule": "Gesamtschule",
        "highSchool": "Gymnasium",
        "elementarySchool": "Grundschule",
        "vocationalSchool": "Erwachsenenbildung",
        "middleSchool": "Mittelstufe",
        "university": "Universität",
        "primarySchool": "Grundschule"
      },
      "exams": {
        "kaarst": {
          "name": "Mathe GK Kurvendiskussion",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "arne": {
          "name": "Mathe 6. Klasse Brüche",
          "description": "Schülerabgaben"
        },
        "lynehamMath": {
          "name": "Mathe",
          "description": "Schülerabgaben"
        },
        "tuevBauleiter": {
          "name": "Bauleiter",
          "description": "Schülerabgaben & Musterlösung"
        },
        "tuvPhotovoltaik": {
          "name": "Photovoltaik",
          "description": "Schülerabgaben & Musterlösung"
        },
        "engVocabulary": {
          "name": "Vokabeltest (Englisch)",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "bioImageLabeling": {
          "name": "Bildbeschriftung (Biologie)",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung & Blanko-Klausur"
        },
        "mathProofFr": {
          "name": "Mathematischer Beweis",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung & Blanko-Klausur"
        },
        "mathProofEng": {
          "name": "Mathematischer Beweis",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung & Blanko-Klausur"
        },
        "plotting": {
          "name": "Graph zeichnen",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung & Blanko-Klausur"
        },
        "curveAnalysis": {
          "name": "Kurvendiskussion",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung & Blanko-Klausur"
        },
        "calculationDe": {
          "name": "Physik",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "dictationFr": {
          "name": "Diktat — Französisch",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "dictationEs": {
          "name": "Diktat — Spanisch",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "calculationFr": {
          "name": "Berechnung",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "calculationEs": {
          "name": "Berechnung",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "calculationEn": {
          "name": "Berechnung",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "multipleChoiceDe": {
          "name": "Multiple Choice",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "multipleChoiceEn": {
          "name": "Multiple Choice",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "multipleChoiceFr": {
          "name": "Multiple Choice",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "multipleChoiceEs": {
          "name": "Multiple Choice",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "politics12German": {
          "name": "Politik — 12. Klasse",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "poetry12German": {
          "name": "Gedichtanalyse — 12. Klasse",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "poetry12English": {
          "name": "Gedichtanalyse — 12. Klasse",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "poetry12French": {
          "name": "Gedichtanalyse — 12. Klasse",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "materialBasedEnglish": {
          "name": "Materialgestütztes Schreiben",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        },
        "materialBasedGerman": {
          "name": "Materialgestütztes Schreiben",
          "description": "Vollständiger Datensatz: Schülerabgaben, Musterlösung, Bewertungsschema & Blanko-Klausur"
        }
      }
    },
    "examEditor": {
      "savingAndRecompiling": "Speichern & neu kompilieren…",
      "unsavedChanges": "Nicht gespeicherte Änderungen",
      "allChangesSaved": "Alle Änderungen gespeichert",
      "readOnlyBanner": "Diese Klausur ist read-only: Es liegt bereits eine Musterlösung, ein Bewertungsschema oder Schülerabgaben vor, die auf der Aufgabenstruktur basieren, daher können hier keine Änderungen mehr vorgenommen werden.",
      "generatingExam": "Klausur wird erstellt…",
      "refiningExam": "Klausur wird angepasst…",
      "downloadPdf": "PDF herunterladen",
      "preparingPdf": "PDF wird vorbereitet…",
      "notSaved": "Nicht gespeichert: {{message}}",
      "seeProblemsBelow": "siehe Probleme unten",
      "noExam": "Keine Klausur.",
      "noSourceYet": "Diese Klausur hat noch keine Quelle.",
      "noPreviewYet": "Noch keine kompilierte Vorschau — auf einen Block oder Punkt klicken, um zu bearbeiten und eine zu erzeugen.",
      "tellAiPlaceholder": "KI mitteilen, was geändert werden soll ...",
      "delete": "Löschen",
      "applying": "Wird angewendet …",
      "send": "Senden",
      "done": "Fertig",
      "describeAiPlaceholder": "Der KI beschreiben, welche Aufgabe hier eingefügt werden soll ...",
      "add": "Hinzufügen",
      "adding": "Wird hinzugefügt …",
      "task": "Aufgabe {{number}}",
      "taskNumber": "Aufgabennummer",
      "type": "Typ",
      "points": "Punkte",
      "lines": "Zeilen",
      "taskText": "Aufgabentext",
      "material": "Material",
      "title": "Titel",
      "usedByTasks": "Verwendet von Aufgaben (kommagetrennte Nummern)",
      "text": "Text",
      "multipleChoice": "Multiple Choice",
      "removeOption": "Option entfernen",
      "addOption": "+ Option hinzufügen",
      "figureProperties": "Abbildungseigenschaften",
      "caption": "Bildunterschrift",
      "examSetup": "Klausureinstellungen",
      "subject": "Fach",
      "class": "Klasse",
      "duration": "Dauer",
      "totalPoints": "Gesamtpunktzahl",
      "globalHints": "Allgemeine Hinweise / Anweisungen",
      "studentView": "Online ausfüllen"
    }
  },
  "TaskTypeDescs": {
    "taskFrame": "Gruppiert Teilaufgaben, erfordert keine eigene Antwort",
    "default": "Allgemeiner Aufgabentyp, wenn kein anderer passt",
    "shortText": "Kurze schriftliche Antwort (wenige Sätze)",
    "essay": "Längerer, strukturierter Fließtext",
    "diagram": "Technische Zeichnung, z.B. Flussdiagramm oder Schaltkreis",
    "sketch": "Freihandzeichnung oder Skizze",
    "gapText": "Lückentext ausfüllen",
    "labelImage": "Teile eines Bildes oder Diagramms beschriften",
    "multipleChoice": "Aus vorgegebenen Optionen auswählen",
    "imageAnalysis": "Bild beschreiben oder interpretieren",
    "mapping": "Passende Objekte/ Alternativen verbinden",
    "legalCase": "Juristischer Fall (Gutachtenstil)",
    "calculation": "Mathematische oder physikalische Berechnung",
    "mathematicalProof": "Formaler mathematischer Beweis",
    "curveAnalysis": "Kurvendiskussion (Nullstellen, Extrema, …)",
    "plotting": "Graph, Funktion oder Punkte im Koordinatensystem einzeichnen",
    "geometry": "Geometrische Konstruktionen oder Berechnungen (Zeichnung)",
    "programming": "Quellcode schreiben oder analysieren",
    "art": "Kunstwerk oder künstlerisches Design erstellen",
    "dictation": "Diktierten Text aufschreiben",
    "translation": "Text oder Wörter in eine andere Sprache übersetzen",
    "chemicalFormula": "Chemische Reaktionsgleichungen oder Formeln",
    "music": "Noten lesen oder schreiben",
    "literaryAnalysisPoetry": "Ein Gedicht analysieren",
    "analysisNonFiction": "Einen Sachtext analysieren",
    "materialBasedEssay": "Text auf Grundlage mehrerer Materialien verfassen"
  },
  "TaskTypes": {
    "taskFrame": "Aufgabenrahmen",
    "default": "Standard",
    "shortText": "Kurztext",
    "essay": "Essay",
    "diagram": "Diagramm",
    "sketch": "Skizze",
    "gapText": "Lückentext",
    "labelImage": "Bild beschriften",
    "multipleChoice": "Multiple Choice",
    "imageAnalysis": "Bildanalyse",
    "mapping": "Zuordnung",
    "legalCase": "Rechtsfall",
    "calculation": "Berechnung",
    "mathematicalProof": "Mathematischer Beweis",
    "curveAnalysis": "Kurvendiskussion",
    "plotting": "Graph zeichnen",
    "geometry": "Geometrie",
    "programming": "Programmierung",
    "art": "Kunst",
    "dictation": "Diktat",
    "translation": "Übersetzung",
    "chemicalFormula": "Chemische Formel",
    "music": "Musik",
    "literaryAnalysisPoetry": "Gedichtanalyse",
    "analysisNonFiction": "Sachtextanalyse",
    "materialBasedEssay": "Materialgestütztes Schreiben"
  },
  "GapText": {
    "gap": "Lücke",
    "correct": "Richtig",
    "incorrect": "Falsch",
    "empty": "Leer",
    "points": "Punkte",
    "expectedAnswer": "Erwartete Antwort",
    "studentAnswer": "Schülerantwort",
    "status": "Status"
  },
  "progress": {
    "analyzingSplit": "Aufteilung wird analysiert",
    "extractingAnswers": "Schülerantworten werden extrahiert...",
    "errorExtractingAnswers": "Fehler beim Extrahieren der Schülerantworten",
    "answersExtracted": "Schülerantworten extrahiert",
    "extractingMasterSolution": "Extrahieren der Musterlösungsinhalte",
    "errorStructureMasterSolution": "Fehler beim Erstellen der Aufgabenstruktur (Musterlösung)",
    "errorExtractingMasterSolution": "Fehler beim Extrahieren der Musterlösung",
    "masterSolutionExtracted": "Musterlösung extrahiert",
    "extractingGradingScheme": "Extrahieren der Bewertungskriterien",
    "errorStructureGradingScheme": "Fehler beim Erstellen der Aufgabenstruktur (Bewertungskriterien)",
    "errorExtractingGradingScheme": "Fehler beim Extrahieren der Bewertungskriterien",
    "gradingSchemeExtracted": "Bewertungskriterien extrahiert",
    "noUsableMasterSolution": "Keine verwertbaren Musterlösungsinhalte erkannt. Bitte Datei prüfen oder Zuordnung anpassen.",
    "noUsableGradingScheme": "Keine verwertbaren Bewertungskriterien erkannt. Bitte Datei prüfen oder Zuordnung anpassen.",
    "analyzingStructure": "Struktur der Klausur wird analysiert",
    "noSubmissions": "Keine Submissions vorhanden",
    "errorStructureAnalysis": "Fehler bei der Strukturanalyse der Klausur",
    "noTasksInStructure": "Keine Aufgaben in der Strukturanalyse gefunden",
    "extractingTaskDescriptions": "Extrahieren der Aufgabenbeschreibungen",
    "errorTaskDescriptions": "Fehler beim Extrahieren der Aufgabenbeschreibungen",
    "taskDescriptionsExtracted": "Aufgabenbeschreibungen extrahiert",
    "taskStructureCreated": "Aufgabenstruktur erstellt",
    "waitingForStructureConfirmation": "Warte auf Bestätigung der Klausurstruktur durch den Nutzer",
    "structureConfirmed": "Klausurstruktur bestätigt",
    "structureConfirmationTimeout": "Bestätigung der Klausurstruktur ist abgelaufen",
    "errorWaitingStructureConfirmation": "Fehler beim Warten auf die Bestätigung der Klausurstruktur",
    "errorProcessingStructureConfirmation": "Fehler beim Verarbeiten der Klausurstruktur-Bestätigung",
    "errorCreatingTaskStructure": "Fehler beim Erstellen der Aufgabenstruktur",
    "pipelineFailedPrematurely": "Pipeline vorzeitig fehlgeschlagen",
    "assignmentConfirmed": "Zuordnung bestätigt",
    "gradingRunning": "Bewertung läuft...",
    "gradingTaskX": "Bewerte Aufgabe {{taskNumber}} ...",
    "gradingCompleted": "Bewertung abgeschlossen",
    "gradingTaskXCompleted": "Bewertung für Aufgabe {{taskNumber}} abgeschlossen"
  },
  "upload": {
    "noExamId": "Keine Klausur-ID gefunden",
    "noFileSelected": "Keine Datei ausgewählt",
    "processingFailed": "Datei konnte nicht verarbeitet werden",
    "invalidFileType": "Ungültiger Dateityp. Bitte wählen Sie eine PNG- oder PDF-Datei.",
    "uploadError": "Fehler beim Hochladen der Datei",
    "studentName": "Schüler {{index}}",
    "noExamIdForReupload": "Fehler: Keine Klausur-ID für Reupload vorhanden.",
    "reuploadCancelled": "SYSTEM INFO: Upload-Abbruch verarbeitet.",
    "reuploadCancelFailed": "SYSTEM INFO: Upload-Abbruch konnte nicht vollständig verarbeitet werden.",
    "filesMissing": "SYSTEM BLOCK: Die folgenden Dateien wurden nicht im Upload-Speicher gefunden: {{files}}. Bitte stelle sicher, dass die Dateinamen exakt mit den hochgeladenen Dateien übereinstimmen.",
    "assignmentMismatch": "SYSTEM BLOCK: Die folgenden Dateizuordnungen stimmen nicht mit dem letzten Vorschlag überein. Bitte rufe send_assignment_confirmation_message auf und bestätige die neue Zuweisung mit dem Nutzer.\n{{lines}}",
    "reuploadStarted": "Der Reupload der Dateien wurde im Hintergrund gestartet. {{extra}}",
    "splitStarted": "Für die Schülerabgaben wurde die Aufteilung gestartet.",
    "assignmentProposalSent": "Nachricht mit Zuweisungsvorschlag gesendet.",
    "assignmentConfirmationMessage": "Ich bin mir bei der Dateizuordnung noch nicht sicher und lasse dich das kurz prüfen.\n\nBitte bestätige im Drag-and-Drop-Bereich, dass die vorgeschlagene Zuordnung stimmt, oder passe sie dort an. Danach kann ich direkt weitermachen.",
    "assignmentProposalFallback": "Bitte prüfe meinen Zuweisungsvorschlag und bestätige die Dateizuordnung.",
    "categorySubmissions": "Schülerabgaben",
    "categoryMasterSolution": "Musterlösung",
    "categoryGradingScheme": "Bewertungsschema",
    "categoryBlankExam": "Leere Klausur",
    "lowConfidenceListFormat": "'{{file}}' (geplant als {{category}})",
    "mismatchFormat": "- {{name}}: zuletzt vorgeschlagen als \"{{proposed}}\", jetzt übergeben als \"{{supplied}}\""
  },
  "splitIssues": {
    "unknownStudent": "Unbekannter Schüler",
    "studentNumber": "Schüler {{number}}",
    "pageAssignmentError": "Nicht jede Seite wurde genau einmal zugeordnet",
    "nonConsecutive": "Nicht aufeinanderfolgende Seiten für {{names}} zugeordnet (Umsortierung durch Agenten)",
    "uncertainty": "Unsicherheit bei {{names}}",
    "outlierLongExtremeSingle": "Abgabe von {{names}} ist extrem lang",
    "outlierLongExtremePlural": "Abgaben von {{names}} sind extrem lang",
    "outlierShortExtremeSingle": "Abgabe von {{names}} ist extrem kurz",
    "outlierShortExtremePlural": "Abgaben von {{names}} sind extrem kurz",
    "outlierLongSingle": "Abgabe von {{names}} ist ungewöhnlich lang",
    "outlierLongPlural": "Abgaben von {{names}} sind ungewöhnlich lang",
    "outlierShortSingle": "Abgabe von {{names}} ist ungewöhnlich kurz",
    "outlierShortPlural": "Abgaben von {{names}} sind ungewöhnlich kurz",
    "missingStudentNameSingle": "Für {{missingCount}} von {{totalCount}} Schüler konnte kein Name extrahiert werden",
    "missingStudentNamePlural": "Für {{missingCount}} von {{totalCount}} Schülern konnte kein Name extrahiert werden",
    "splitAgentFailure": "Split-Agent Fehler{{suffix}}",
    "errorPrefix": "Fehler",
    "warningPrefix": "Warnung",
    "parseErrorFallback": "Die Daten konnten nicht verarbeitet werden. Bitte überprüfe die Zuordnung im Canvas.",
    "messageError": "Ich habe {{count}} Schüler mit je {{range}} Seiten gefunden, aber es ist ein Problem bei der automatischen Zuweisung der Seiten aufgetreten:\n{{problem}}\n\nBitte prüfe die Zuweisung im Zuordnungs-Canvas und korrigiere sie bei Bedarf manuell. Sobald du fertig bist bestätige bitte im Chat oder über den Button, damit wir fortfahren können.",
    "messageWarning": "Ich habe {{count}} Schüler mit je {{range}} Seiten gefunden, aber es gibt folgende Hinweise:\n{{problem}}\n\nFalls du möchtest, kannst du die Hinweise im Zuordnungs-Canvas überprüfen. Ansonsten bestätige einfach, damit wir fortfahren können.",
    "messageSuccess": "Ich habe {{count}} Schüler mit je {{range}} Seiten gefunden. Die Zuordnung war eindeutig. Bei allen Schülern konnte ein Name extrahiert werden. Bitte bestätige, damit wir fortfahren können.",
    "confirmationRequested": "Aufteilungsbestätigung angefordert",
    "splitAgentFailed": "Die automatische Zuordnung der Schülerabgaben ist fehlgeschlagen. Bitte versuche den Upload später erneut."
  },
  "structureIssues": {
    "textCutoff": "Aufgabentext unvollständig",
    "missingInformation": "fehlende Informationen",
    "imageUnreadable": "Bild nicht lesbar",
    "task": "Aufgabe",
    "mainTasks_one": "Ich habe {{mainCount}} Hauptaufgabe erkannt.",
    "mainTasks_other": "Ich habe {{mainCount}} Hauptaufgaben erkannt.",
    "mainAndSubTasks_one": "Ich habe {{mainCount}} Hauptaufgaben und {{subCount}} Teilaufgabe erkannt.",
    "mainAndSubTasks_other": "Ich habe {{mainCount}} Hauptaufgaben und {{subCount}} Teilaufgaben erkannt.",
    "intro": "### Ich habe die folgende Aufgabenstruktur identifiziert:\n\n{{countText}}",
    "problemsIntro": "\n\nBei der Aufgabenerkennung sind folgende Probleme aufgetreten: {{warnings}}. Bitte schaue dir die Unsicherheiten im Canvas an, bearbeite sie bei Bedarf und bestätige dann über den Button oder im Chat.",
    "uncertaintyIntro": "\n\nBei der Aufgabenerkennung gibt es bei {{labels}} Unsicherheiten. Bitte schaue dir die Unsicherheiten im Canvas an, bearbeite sie bei Bedarf und bestätige dann über den Button oder im Chat.",
    "success": "\n\nBei der Aufgabenerkennung sind keine Probleme aufgetreten. Wenn du möchtest kannst du sie dir trotzdem im Canvas genauer anschauen, ansonsten bestätige bitte über den Button oder im Chat.",
    "pointsExplanation": "\n\n**Zu den Punkten:** Ich habe für einige Aufgaben Punkte erkannt. Falls du ein Bewertungsschema mit Punktangaben hochlädst (oder bereits hochgeladen hast), werden die Punkte von dort übernommen – die Punkte im Canvas kannst du dann ignorieren. Sie sind nur relevant falls dein Bewertungsschema diese Angabe nicht enthält oder du eins erstellen lassen möchtest.\n\nRegeln zur Punktevergabe: Vergib pro Aufgabe entweder allen direkten Teilaufgaben Punkte, die zur Gesamtpunktzahl der übergeordneten Aufgabe summieren, oder keiner. Weist du den Teilaufgaben keine Punkte zu, sondern nur eine Gesamtpunktzahl, verteilt die KI die Punkte später bei der Generierung des Bewertungsschemas automatisch."
  },
  "chatMessages": {
    "emptyState": "Starte eine Unterhaltung, indem du unten eine Nachricht eingibst",
    "newMessage": "Neue Nachricht",
    "cancel": "Abbrechen",
    "send": "Senden",
    "edit": "Bearbeiten",
    "editInCanvas": "Im Canvas bearbeiten",
    "confirmed": "Bestätigt",
    "confirm": "Bestätigen",
    "confirmAssignment": "Zuordnung bestätigen",
    "giveFeedback": "Feedback geben",
    "feedbackTitle": "Feedback geben",
    "feedbackDescription": "Teile uns mit, wie wir diese Antwort verbessern können.",
    "feedbackPlaceholder": "Dein Feedback hier...",
    "feedbackSubmit": "Feedback senden",
    "submitAssignmentConfirmation": "Ich bestätige die Aufteilung der Seiten und die Zuordnung zu den Schülern. Bitte fahre fort.",
    "submitStructureConfirmation": "Ich bestätige die Aufgabenstruktur",
    "studentSubmissions": "Schülerabgaben",
    "masterSolution": "Musterlösung",
    "gradingScheme": "Bewertungsschema",
    "blankExam": "Leere Klausur",
    "confirmedAssignmentIntro": "Die bestätigte Dateizuordnung:",
    "assignmentIntro": "Ich habe die Dateien wie folgt zugeordnet. Bitte überprüfe die Zuordnung und bestätige sie:"
  },
  "AuthModal": {
    "loginError": "E-Mail oder Passwort ist falsch.",
    "signupFailed": "Registrierung fehlgeschlagen. Bitte versuche es erneut.",
    "passwordMismatch": "Die Passwörter stimmen nicht überein.",
    "forgotPasswordProblem": "Es gab ein Problem. Bitte versuche es später erneut.",
    "waitlistTitle": "Du stehst auf der Liste!",
    "waitlistDesc": "Wir melden uns bei dir, sobald die nächste Phase startet.",
    "waitlistInactive": "Warteliste aktuell deaktiviert.",
    "backToLogin": "Zurück zum Login",
    "linkSentTitle": "Link gesendet!",
    "linkSentDesc": "Verstanden",
    "forgotPasswordTitle": "Passwort vergessen?",
    "requestLink": "Link anfordern",
    "welcomeBack": "Willkommen zurück",
    "createAccount": "Account erstellen",
    "emailLabel": "E-Mail",
    "passwordLabel": "Passwort",
    "forgotPasswordLink": "Passwort vergessen?",
    "loginButton": "Anmelden",
    "roleLabel": "Ich bin",
    "roleTeacher": "Lehrer",
    "roleStudent": "Schüler",
    "firstNameLabel": "Vorname",
    "lastNameLabel": "Nachname",
    "schoolLabel": "Schule",
    "subjectsLabel": "Fächer",
    "confirmPasswordLabel": "Bestätigen",
    "signupButton": "Registrieren",
    "registerHere": "Hier registrieren",
    "loginHere": "Hier anmelden",
    "continueGuest": "Ohne Anmeldung fortfahren →"
  },
  "FeedbackPage": {
    "alerts": {
      "imageTooLarge": "Das Bild \"{{name}}\" ist zu groß (max. 5MB).",
      "previewError": "Preview konnte für {{name}} nicht erstellt werden.",
      "submitError": "Da ist etwas schiefgelaufen. Bitte versuche es nochmal."
    },
    "success": {
      "title": "Vielen Dank für dein Feedback!",
      "description": "Wir haben deine Nachricht erhalten. Dein Input hilft uns enorm dabei, Gradias jeden Tag ein bisschen besser zu machen.",
      "backButton": "Zurück zur Klausur"
    },
    "header": {
      "title": "Feedback geben"
    },
    "content": {
      "description": "Dir ist ein Fehler aufgefallen, du hast eine geniale Idee oder möchtest uns einfach etwas mitteilen? Wir lesen jede Nachricht!"
    },
    "categories": {
      "title": "Um was geht es?",
      "bug": {
        "title": "Fehler / Bug",
        "desc": "Etwas funktioniert nicht"
      },
      "feature": {
        "title": "Idee / Wunsch",
        "desc": "Ein neues Feature"
      },
      "general": {
        "title": "Sonstiges",
        "desc": "Allgemeines Feedback"
      }
    },
    "message": {
      "title": "Deine Nachricht",
      "placeholder": "Beschreibe dein Anliegen so detailliert wie möglich..."
    },
    "upload": {
      "title": "Screenshot anhängen (Optional)",
      "clickToSelect": "Klicke, um Bilder auszuwählen",
      "formatConstraint": "PNG, JPG bis max. 5MB pro Bild",
      "attachedImages": "Angehängte Bilder",
      "removeImage": "Bild entfernen"
    },
    "submit": {
      "sending": "Wird gesendet...",
      "send": "Feedback absenden"
    }
  },
  "ConfirmationReplies": {
    "split": {
      "confirmed": "Die Klausur-Zuweisung und Anzahl der Schüler wurde erfolgreich bestätigt. Die Extraktion der Aufgabenstruktur kann nun gestartet werden. Bitte bedanke dich beim Nutzer für die Bestätigung der Zuweisung und teile dem Nutzer im Chat mit, dass nun die Extraktion der Aufgabenstruktur gestartet wird.",
      "pending": "Die Klausur-Zuweisung und Anzahl der Schüler ist noch nicht bestätigt."
    },
    "structure": {
      "masterAndGrading": "Die Aufgabenstruktur wurde erfolgreich bestätigt. Die Extraktion läuft nun weiter im Hintergrund. Eine Musterlösung und ein Bewertungsschlüssel sind bereits hochgeladen worden und werden im Hintergrund verarbeitet. Bedanke dich beim Nutzer kurz für die Bestätigung der Aufgabenstruktur und teile dem Nutzer kurz mit, dass die Extraktion fortgesetzt wird. Schlage ihm vor, dass Grading zu starten.",
      "masterOnly": "Die Aufgabenstruktur wurde erfolgreich bestätigt. Die Extraktion läuft nun weiter im Hintergrund. Eine Musterlösung ist bereits hochgeladen, es fehlt aber noch der Bewertungsschlüssel. Bedanke dich beim Nutzer kurz für die Bestätigung der Aufgabenstruktur und teile dem Nutzer kurz mit, dass die Extraktion fortgesetzt wird. Schlage ihm vor, dass du als nächsten Schritt ein KI-basiertes Bewertungsschema erstellst.",
      "gradingOnly": "Die Aufgabenstruktur wurde erfolgreich bestätigt. Die Extraktion läuft nun weiter im Hintergrund. Ein Bewertungsschlüssel ist bereits hochgeladen, es fehlt aber noch die Musterlösung. Bedanke dich beim Nutzer kurz für die Bestätigung der Aufgabenstruktur und teile dem Nutzer kurz mit, dass die Extraktion fortgesetzt wird. Schlage ihm vor, dass du eine KI-basierte Musterlösung erstellst.",
      "none": "Die Aufgabenstruktur wurde erfolgreich bestätigt. Die Extraktion läuft nun weiter im Hintergrund. Es fehlt noch die Musterlösung. Bedanke dich beim Nutzer kurz für die Bestätigung der Aufgabenstruktur, teile dem Nutzer kurz mit, dass die Extraktion fortgesetzt wird und frage den Nutzer, ob du im nächsten Schritt, sobald die Extraktion abgeschlossen ist, eine KI-basierte Musterlösung generieren sollst oder ob er noch eine Musterlösung über die Büroklammer im Eingabefeld hochladen möchte. Erwähne in deiner Antwort wie der Nutzer die Musterlösung hochladen kann, also mit der Büroklammer im Chat-Eingabefeld."
    },
    "errors": {
      "notConfirmed": "Confirmation flag is false; nothing to do.",
      "missingIdentifiers": "Missing required identifiers for confirmation.",
      "missingSplitMessage": "Fehler: Keine zugeordnete Split-Bestätigungsnachricht gefunden.",
      "missingStructureMessage": "Fehler: Keine zugeordnete Struktur-Bestätigungsnachricht gefunden.",
      "structureContentMissing": "Fehler: Struktur-Bestätigungsnachricht konnte nicht geladen werden.",
      "splitFailure": "Fehler beim Bestätigen der Aufteilung.",
      "structureFailure": "Fehler beim Bestätigen der Struktur."
    }
  },
  "toolFallbackDesc": {
    "default": "Toolschritt ausführen",
    "set_metadata": "Metadaten der Klausur",
    "create_exam": "Klausur jetzt erstellen",
    "generate_master_solution": "Musterlösung jetzt erstellen",
    "refine_master_solution": "Musterlösung gezielt verbessern",
    "generate_grading_scheme": "Bewertungsschema jetzt erstellen",
    "refine_grading_scheme": "Bewertungsschema gezielt verbessern",
    "run_grading_agent": "Bewertung durchführen",
    "set_task_score": "Punktzahl manuell setzen",
    "open_canvas": "Canvas Ansicht öffnen",
    "update_open_task_content": "Aufgabentext direkt aktualisieren",
    "send_assignment_confirmation_message": "Dateizuordnung bestätigen lassen",
    "process_files": "Hochgeladene Dateien verarbeiten",
    "confirm_split_in_chat": "Zuordnung im Chat bestätigen",
    "confirm_structure_in_chat": "Struktur im Chat bestätigen",
    "query_exams": "Klausurdaten abrufen",
    "query_submissions": "Schülerabgaben abrufen",
    "get_available_options": "Verfügbare Optionen abrufen",
    "get_task_types": "Aufgabentypen abrufen",
    "download_ms_gs": "Musterlösung/Bewertungsschema herunterladen",
    "download_summary_reports": "Auswertungsbericht herunterladen",
    "save_teacher_memory": "Präferenz merken",
    "get_teacher_memory": "Präferenzen nachschlagen",
    "delete_teacher_memory": "Präferenzen löschen",
    "reprocess_errored_submissions": "Fehlerhafte Abgaben erneut verarbeiten"
  },
  "Subjects": {
    "math": "Mathematik",
    "physics": "Physik",
    "chemistry": "Chemie",
    "biology": "Biologie",
    "history": "Geschichte",
    "geography": "Erdkunde",
    "english": "Englisch",
    "german": "Deutsch",
    "french": "Französisch",
    "spanish": "Spanisch",
    "computer_science": "Informatik",
    "social_studies": "Sozialkunde",
    "other": "Sonstiges"
  },
  "ExamNotifications": {
    "newMessage": "Neue Nachricht"
  },
  "LanguageUseTemplates": {
    "essay": "Niveaustufen · Darstellungsleistung\n\n* hervorragend:\n  - Text ist klar und logisch gegliedert, mit wirkungsvoller Verknüpfung der Abschnitte.\n  - Fachsprache wird sicher und präzise verwendet.\n  - Zitate werden korrekt integriert und textbezogen eingeführt; Belege mit Zeilenangabe.\n  - Syntax ist abwechslungsreich, stilistisch sicher und dem literarischen Gegenstand angemessen.\n  - Grammatik, Rechtschreibung und Zeichensetzung sind nahezu fehlerfrei.\n* gut:\n  - Text ist schlüssig gegliedert.\n  - Fachsprache wird überwiegend sicher verwendet.\n  - Zitate sind angemessen eingesetzt und korrekt belegt.\n  - Syntax ist korrekt und abwechslungsreich.\n  - Wenige Verstöße gegen Grammatik, Rechtschreibung und Zeichensetzung.\n* befriedigend:\n  - Gliederung ist erkennbar, aber nicht durchgängig stringent.\n  - Fachsprache wird funktional, aber nicht immer präzise eingesetzt.\n  - Zitate werden verwendet, Belege sind überwiegend korrekt.\n  - Syntax ist überwiegend korrekt, stellenweise monoton.\n  - Verstöße gegen Grammatik, Rechtschreibung und Zeichensetzung beeinträchtigen das Verständnis nicht.\n* ausreichend:\n  - Gliederung ist rudimentär erkennbar.\n  - Fachsprache wird nur teilweise verwendet oder ist ungenau.\n  - Zitate sind uneinheitlich oder unvollständig belegt.\n  - Syntax ist einförmig, mit gehäuften Unsicherheiten.\n  - Sprachrichtigkeit ist eingeschränkt; das Verständnis wird gelegentlich erschwert.\n* mangelhaft:\n  - Die Darstellung ist weitgehend unstrukturiert.\n  - Fachsprache fehlt weitgehend oder wird falsch eingesetzt.\n  - Zitate fehlen oder sind unkorrekt.\n  - Sprachliche Mängel beeinträchtigen das Verständnis deutlich.\n* ungenügend:\n  - Die Darstellung ist so mangelhaft, dass die Arbeit kaum verständlich ist.\n  - Die Grundanforderungen an einen schriftlichen Interpretationsaufsatz sind nicht erkennbar.",
    "analysisNonFiction": "Niveaustufen · Darstellungsleistung\n\n* hervorragend:\n  - Text ist klar und logisch gegliedert, mit wirkungsvoller Verknüpfung der Abschnitte.\n  - Fachsprache wird sicher und präzise verwendet.\n  - Zitate werden korrekt integriert und textbezogen eingeführt; Belege mit Zeilenangabe.\n  - Syntax ist abwechslungsreich, stilistisch sicher und dem literarischen Gegenstand angemessen.\n  - Grammatik, Rechtschreibung und Zeichensetzung sind nahezu fehlerfrei.\n* gut:\n  - Text ist schlüssig gegliedert.\n  - Fachsprache wird überwiegend sicher verwendet.\n  - Zitate sind angemessen eingesetzt und korrekt belegt.\n  - Syntax ist korrekt und abwechslungsreich.\n  - Wenige Verstöße gegen Grammatik, Rechtschreibung und Zeichensetzung.\n* befriedigend:\n  - Gliederung ist erkennbar, aber nicht durchgängig stringent.\n  - Fachsprache wird funktional, aber nicht immer präzise eingesetzt.\n  - Zitate werden verwendet, Belege sind überwiegend korrekt.\n  - Syntax ist überwiegend korrekt, stellenweise monoton.\n  - Verstöße gegen Grammatik, Rechtschreibung und Zeichensetzung beeinträchtigen das Verständnis nicht.\n* ausreichend:\n  - Gliederung ist rudimentär erkennbar.\n  - Fachsprache wird nur teilweise verwendet oder ist ungenau.\n  - Zitate sind uneinheitlich oder unvollständig belegt.\n  - Syntax ist einförmig, mit gehäuften Unsicherheiten.\n  - Sprachrichtigkeit ist eingeschränkt; das Verständnis wird gelegentlich erschwert.\n* mangelhaft:\n  - Die Darstellung ist weitgehend unstrukturiert.\n  - Fachsprache fehlt weitgehend oder wird falsch eingesetzt.\n  - Zitate fehlen oder sind unkorrekt.\n  - Sprachliche Mängel beeinträchtigen das Verständnis deutlich.\n* ungenügend:\n  - Die Darstellung ist so mangelhaft, dass die Arbeit kaum verständlich ist.\n  - Die Grundanforderungen an einen schriftlichen Interpretationsaufsatz sind nicht erkennbar.",
    "genericGroup": "Niveaustufen · Darstellungsleistung\n\n* hervorragend:\n  - Text ist klar und logisch gegliedert, mit wirkungsvoller Verknüpfung der Abschnitte.\n  - Fachsprache wird sicher und präzise verwendet.\n  - Zitate werden korrekt integriert und textbezogen eingeführt; Belege mit Zeilenangabe.\n  - Syntax ist abwechslungsreich, stilistisch sicher und dem literarischen Gegenstand angemessen.\n  - Grammatik, Rechtschreibung und Zeichensetzung sind nahezu fehlerfrei.\n* gut:\n  - Text ist schlüssig gegliedert.\n  - Fachsprache wird überwiegend sicher verwendet.\n  - Zitate sind angemessen eingesetzt und korrekt belegt.\n  - Syntax ist korrekt und abwechslungsreich.\n  - Wenige Verstöße gegen Grammatik, Rechtschreibung und Zeichensetzung.\n* befriedigend:\n  - Gliederung ist erkennbar, aber nicht durchgängig stringent.\n  - Fachsprache wird funktional, aber nicht immer präzise eingesetzt.\n  - Zitate werden verwendet, Belege sind überwiegend korrekt.\n  - Syntax ist überwiegend korrekt, stellenweise monoton.\n  - Verstöße gegen Grammatik, Rechtschreibung und Zeichensetzung beeinträchtigen das Verständnis nicht.\n* ausreichend:\n  - Gliederung ist rudimentär erkennbar.\n  - Fachsprache wird nur teilweise verwendet oder ist ungenau.\n  - Zitate sind uneinheitlich oder unvollständig belegt.\n  - Syntax ist einförmig, mit gehäuften Unsicherheiten.\n  - Sprachrichtigkeit ist eingeschränkt; das Verständnis wird gelegentlich erschwert.\n* mangelhaft:\n  - Die Darstellung ist weitgehend unstrukturiert.\n  - Fachsprache fehlt weitgehend oder wird falsch eingesetzt.\n  - Zitate fehlen oder sind unkorrekt.\n  - Sprachliche Mängel beeinträchtigen das Verständnis deutlich.\n* ungenügend:\n  - Die Darstellung ist so mangelhaft, dass die Arbeit kaum verständlich ist.\n  - Die Grundanforderungen an einen schriftlichen Interpretationsaufsatz sind nicht erkennbar.",
    "materialBasedEssay": "Materialgestütztes Schreiben (Verfassen argumentierender / informierender Texte)\n\nInhaltliche Leistung & Materialnutzung (Verstehensleistung / Textstruktur):\n* Die Einleitung ist knapp, weckt das Interesse der Leserschaft und führt zum Thema hin (floskelhafte Überleitungen werden vermieden).\n* Eine sinnvolle Gliederung ist erkennbar, die allen Bausteinen der geforderten Zieltextsorte (z. B. Kommentar, Essay, Beitrag) entspricht.\n* Das Thema und die damit verbundene Problemstellung werden zu Beginn klar umrissen.\n* Wichtige Grundbegriffe werden bei Bedarf sachgemäß erklärt.\n* Alle vorgelegten Materialien werden berücksichtigt und sinnvoll sowie inhaltlich korrekt in den Text eingebunden.\n* Transparenz bei Fremdaussagen ist gegeben (korrektes Zitieren, Paraphrasieren und Verweisen auf die Quellen).\n* Zwischen der Darstellung des Sachverhalts, der Argumentation und der eigenen Wertung wird klar unterschieden.\n* Die Argumentation ist breit und differenziert angelegt (berücksichtigt verschiedene Aspekte des Themas sowie mögliche Gegenargumente).\n* Einzelne Argumente sind für den Adressatenkreis überzeugend, klar strukturiert, erläutert und mit Belegen/Beispielen gestützt.\n* Neben Argumenten aus den Materialien werden eigenständige Argumente und eigenes Fachwissen eingebracht.\n* Die Argumentation wird am Schluss in einem Fazit gebündelt, dem sich ggf. ein Ausblick auf die Zukunft anschließt.\n\nSprachliche Leistung & Textgestaltung (Darstellungsleistung):\n* Die sprachliche Gestaltung entspricht der geforderten Textsorte mit klarer, präziser Sprache und eigenständigen Formulierungen.\n* Das Vokabular, die Beherrschung von Fachbegriffen und der funktionale Stil sind präzise, differenziert und stilistisch angemessen.\n* Der Satzbau ist überschaubar, variantenreich und grammatikalisch komplex.\n* Normfehler (in Grammatik, Rechtschreibung und Zeichensetzung) beeinträchtigen den Lesefluss nicht.",
    "literaryAnalysisPoetry": "Darstellungsleistung\n* 1. Der Prüfling strukturiert seinen Text kohärent, schlüssig, stringent und gedanklich klar:\n  - angemessene Gewichtung der Teilaufgaben in der Durchführung\n  - gegliederte und angemessen gewichtete Anlage der Arbeit\n  - schlüssige Verbindung der einzelnen Arbeitsschritte\n  - schlüssige gedankliche Verknüpfung von Sätzen\n* 2. Der Prüfling formuliert unter Beachtung der fachsprachlichen und fachmethodischen Anforderungen:\n  - Trennung von Handlungs- und Metaebene\n  - begründeter Bezug von beschreibenden, deutenden und wertenden Aussagen\n  - Verwendung von Fachtermini in sinnvollem Zusammenhang\n  - Beachtung der Tempora\n  - korrekte Redewiedergabe (Modalität)\n* 3. Der Prüfling belegt Aussagen durch angemessenes und korrektes Zitieren:\n  - sinnvoller Gebrauch von vollständigen oder gekürzten Zitaten in begründender Funktion\n* 4. Der Prüfling drückt sich allgemeinsprachlich präzise, stilistisch sicher und begrifflich differenziert aus:\n  - sachlich-distanzierte Schreibweise\n  - Schriftsprachlichkeit\n  - begrifflich abstrakte Ausdrucksfähigkeit\n* 5. Der Prüfling formuliert lexikalisch und syntaktisch sicher, variabel und komplex (und zugleich klar).\n* 6. Der Prüfling schreibt sprachlich richtig."
  },
  "LatexEditor": {
    "insertFormula": "Formel",
    "insertFormulaHint": "Neue Formel an der Cursorposition einfügen",
    "switchToRawLatex": "Zu rohem LaTeX wechseln",
    "switchToVisualEditor": "Zum visuellen Editor wechseln",
    "naturalLanguageHint": "Diese Formel in natürlicher Sprache beschreiben",
    "naturalLanguagePlaceholder": "z. B. „Integral von 0 bis 10 von x²“",
    "naturalLanguageError": "Übersetzung fehlgeschlagen. Bitte versuche es erneut.",
    "insert": "Einfügen",
    "removeFormula": "Formel entfernen",
    "cancel": "Abbrechen"
  },
  "StudentExam": {
    "loading": "Klausur wird geladen…",
    "examFallbackTitle": "Klausur",
    "classLabel": "Klasse {{class}}",
    "namePlaceholder": "Dein Name",
    "answeredCount": "{{answered}} / {{total}} beantwortet",
    "submit": "Abgeben",
    "signInRequiredTitle": "Anmeldung erforderlich",
    "signInRequiredBody": "Melde dich an, um diese Klausur zu bearbeiten.",
    "signInAction": "Zur Anmeldung",
    "unavailableTitle": "Nicht verfügbar",
    "submittedTitle": "Abgegeben",
    "submittedBody": "Deine Antworten wurden gespeichert und stehen zur Korrektur bereit.",
    "errors": {
      "loadFailed": "Die Klausur konnte nicht geladen werden.",
      "notFound": "Diese Klausur gibt es nicht.",
      "notSignedIn": "Nicht angemeldet.",
      "noAccess": "Klausur nicht gefunden oder kein Zugriff.",
      "noTasks": "Diese Klausur hat noch keine Aufgaben.",
      "uploadedExam": "Diese Klausur wurde hochgeladen, nicht erstellt — sie kann online nicht ausgefüllt werden.",
      "studentsOnly": "Das Online-Ausfüllen ist nur für Schüler-Konten verfügbar.",
      "renderFailed": "Die Klausur konnte nicht dargestellt werden.",
      "unreadableAnswers": "Antworten konnten nicht gelesen werden.",
      "submitFailed": "Abgabe fehlgeschlagen."
    },
    "canvas": {
      "undo": "Zurück",
      "clear": "Leeren",
      "pen": "Stift",
      "eraser": "Radierer",
      "redo": "Wiederholen",
      "zoom": "Vergrößert zeichnen",
      "zoomClose": "Vergrößerung schließen",
      "penWidth": "Stiftstärke {{width}}"
    }
  }
}
